import { render, staticRenderFns } from "./Qa.vue?vue&type=template&id=7868e1ce&scoped=true"
import script from "./Qa.vue?vue&type=script&lang=js"
export * from "./Qa.vue?vue&type=script&lang=js"
import style0 from "./Qa.vue?vue&type=style&index=0&id=7868e1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7868e1ce",
  null
  
)

export default component.exports